
























































































import {
  computed, defineComponent, reactive, ref,
} from '@vue/composition-api';
import { useQuery, useResult } from '@vue/apollo-composable';
import { useFormat } from 'vivat';

import getDeliveryFeeSummary from '@/gql/report/analytic/getDeliveryFeeSummary.gql';

import CommonIconTop from '@/components/CommonIconTop.vue';

import useHighChartMap from '@/useHighChartMap';

const NOW = new Date();

const IncomeByTransferItem = defineComponent({
  components: {
    CommonIconTop,
  },
  setup() {
    const { getProperty } = useHighChartMap();
    const toDate = (date: string) => useFormat.date(date).displayFullThaiDate();
    const getYear = (date: string) => useFormat.date(date).dayjs.get('year');
    const toCurrency = (string: string) => parseFloat(string || '0').toLocaleString('th-TH', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    const backwardTenYear = Array.from({ length: 10 }, (x, i) => new Date().getFullYear() + 543 - i);
    const filter = reactive({
      range: {
        from: useFormat.date(NOW).computerShortDate(),
        to: useFormat.date(NOW).computerShortDate(),
      },
    });
    const computedFilter = computed(() => {
      if (filter.range.from === filter.range.to) return {};
      return {
        range: {
          from: useFormat.date(filter.range.from).computerShortDate(),
          to: useFormat.date(filter.range.to).computerShortDate(),
        },
      };
    });

    const { result: getDeliveryFeeSummaryResult } = useQuery(getDeliveryFeeSummary, () => ({
      timeframe: computedFilter.value.range,
    }));
    const months = useResult(getDeliveryFeeSummaryResult, [], (data) => data.deliveryFeeMonthly);
    const feePerKg = useResult(getDeliveryFeeSummaryResult, 0, (data) => data.deliveryFeeAverage.feePerKg);
    const feePerPack = useResult(getDeliveryFeeSummaryResult, 0, (data) => data.deliveryFeeAverage.feePerPack);
    const feePerPc = useResult(getDeliveryFeeSummaryResult, 0, (data) => data.deliveryFeeAverage.feePerPc);
    const feePerVolume = useResult(getDeliveryFeeSummaryResult, 0, (data) => data.deliveryFeeAverage.feePerVolume);
    const deliveryFeePackageUnits = useResult(getDeliveryFeeSummaryResult, [], (data) => data.deliveryFeePackageUnits);

    const thMonthsMini = ['ม.ค.', 'ก.พ.', 'มี.ค.', 'เม.ย.', 'พ.ค.', 'มิ.ย.', 'ก.ค.', 'ส.ค.', 'ก.ย.', 'ต.ค.', 'พ.ย.', 'ธ.ค.'];
    const selectedYear = ref(new Date().getFullYear() + 543);
    const computedSeriesData = computed(() => {
      const perPc: any[] = [];
      const perKg: any[] = [];
      const perVolume: any[] = [];
      const perPack: any[] = [];

      months.value.forEach((val: any) => {
        perPc.push({
          x: thMonthsMini[val.month - 1],
          y: val.feePerPc,
        });
      });

      return {
        perPc,
        perKg,
        perVolume,
        perPack,
      };
    });

    const areaCharts = computed(() => ({
      options: {
        dataLabels: { enabled: false },
        yaxis: {
          opposite: false,
          labels: {
            formatter: (val: any) => toCurrency(val),
          },
        },
      },
      series: [
        {
          name: 'ดัชนีราคาขนส่ง (ต่อชิ้น)',
          data: computedSeriesData.value.perPc,
        },
      ],
    }));

    return {
      toCurrency,
      toDate,
      getYear,
      filter,

      months,

      areaCharts,
      backwardTenYear,
      selectedYear,

      deliveryFeePackageUnits,
      feePerKg,
      feePerPack,
      feePerPc,
      feePerVolume,
    };
  },
});

export default IncomeByTransferItem;
